const config = {
 apiUrl: window._env_.VUE_APP_API_URL || process.env.VUE_APP_API_URL
 //dapiUrl: process.env.VUE_APP_API_URL
};

export default { ...config };
